export function parseAuthSessionResponse(value) {
    const record = objectRecord(value, 'AuthSessionResponse');
    return {
        success: booleanField(record, 'success'),
        sessionJwt: nullableStringField(record, 'sessionJwt'),
        refreshToken: nullableStringField(record, 'refreshToken'),
        expiresAt: nullableNumberField(record, 'expiresAt'),
        activeTenantId: nullableStringField(record, 'activeTenantId'),
        tenantMemberships: arrayField(record, 'tenantMemberships').map(parseTenantMembership),
        error: nullableStringField(record, 'error'),
    };
}
export function parseSwitchTenantResponse(value) {
    const record = objectRecord(value, 'SwitchTenantResponse');
    return {
        success: booleanField(record, 'success'),
        sessionJwt: nullableStringField(record, 'sessionJwt'),
        expiresAt: nullableNumberField(record, 'expiresAt'),
        error: nullableStringField(record, 'error'),
    };
}
export function parseCognitoOtpChallenge(email, session) {
    return { email, session: requiredString(session, 'Cognito Session') };
}
export function parseCognitoOtpTokens(value, fallbackRefreshToken) {
    const auth = objectRecord(value, 'Cognito AuthenticationResult');
    return {
        idToken: requiredString(auth.IdToken, 'Cognito IdToken'),
        accessToken: requiredString(auth.AccessToken, 'Cognito AccessToken'),
        refreshToken: requiredString(auth.RefreshToken ?? fallbackRefreshToken, 'Cognito RefreshToken'),
    };
}
export function objectRecord(value, label) {
    if (typeof value !== 'object' || value === null || Array.isArray(value)) {
        throw new Error(`FAIL: ${label} must be an object`);
    }
    return value;
}
export function requiredString(value, label) {
    if (typeof value !== 'string' || value.trim().length === 0) {
        throw new Error(`FAIL: ${label} is required`);
    }
    return value;
}
function parseTenantMembership(value) {
    const record = objectRecord(value, 'TenantMembership');
    return {
        tenantId: requiredString(record.tenantId, 'TenantMembership tenantId'),
        role: requiredString(record.role, 'TenantMembership role'),
    };
}
function booleanField(record, field) {
    const value = record[field];
    if (typeof value !== 'boolean')
        throw new Error(`FAIL: ${field} must be a boolean`);
    return value;
}
function nullableStringField(record, field) {
    const value = record[field];
    if (value === null || value === undefined)
        return null;
    if (typeof value !== 'string')
        throw new Error(`FAIL: ${field} must be a string`);
    return value;
}
function nullableNumberField(record, field) {
    const value = record[field];
    if (value === null || value === undefined)
        return null;
    if (typeof value !== 'number' || !Number.isFinite(value))
        throw new Error(`FAIL: ${field} must be a number`);
    return value;
}
function arrayField(record, field) {
    const value = record[field];
    if (value === null || value === undefined)
        return [];
    if (!Array.isArray(value))
        throw new Error(`FAIL: ${field} must be an array`);
    return value;
}
//# sourceMappingURL=dto.js.map